export default __webpack_public_path__ + "static/media/icons8-glassrepairreplacement.9abd6ce5.svg";